import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { BodyTextSmall, ComponentTextSmall, HeadingText20, } from '../Typography/Typography';
import { ProgressBar } from '../ProgressBar/ProgressBar';
import * as styles from './Stepper.module.scss';
/**
 * Stepper component [...]
 * https://www.figma.com/file/sMa3TXhnJ8CYokX3vNcvzf/%F0%9F%A7%A9-Component-Library?node-id=418%3A0
 */
export const Stepper = ({ shortNames, step: inputStep, className, testID, label, formatNextStep, }) => {
    const totalSteps = shortNames.length;
    const step = Math.min(Math.max(inputStep, 1), totalSteps);
    if (totalSteps < 1) {
        return null;
    }
    return (_jsxs("div", { className: clsx([styles.container, className]), "data-testid": testID, "aria-label": label, children: [_jsxs("div", { className: styles.progressBarContainer, children: [_jsx(ComponentTextSmall, { children: label }), _jsx("div", { className: styles.progressBar, children: _jsx(ProgressBar, { progress: step / totalSteps }) })] }), _jsxs("div", { className: styles.shortNamesContainer, children: [_jsx(HeadingText20, { as: "p", children: shortNames[step - 1] }), step < totalSteps && (_jsx(BodyTextSmall, { as: "p", children: formatNextStep(shortNames[step]) }))] })] }));
};
